module.exports = __webpack_public_path__ + "img/9788964450277.f9e0ee99.jpg";